import { z } from "zod"

import { powurOsResponseSchema } from "./base"
import { powurOsLoanFeeSchema } from "../models/loan-fee"

export const getLoanFeeResponseSchema = powurOsResponseSchema.extend({
  model: z.array(powurOsLoanFeeSchema).nullable(),
})

export type GetLoanFeeResponse = z.infer<typeof getLoanFeeResponseSchema>
